<script>
  import { onMount } from 'svelte';
  import WeightChart from './WeightChart.svelte';
  import WorkoutCalendar from './WorkoutCalendar.svelte';
  import { getWeightRecords, getWorkoutStats, formatDuration } from '../services/db';
  import { syncStatus } from '../stores/app.js';

  let weightRecords = [];
  let stats = {
    consecutiveWeeks: 0,
    totalWorkouts: 0,
    totalDuration: 0,
    totalVolume: 0
  };
  let previousSyncState = false;

  async function loadData() {
    weightRecords = await getWeightRecords();
    stats = await getWorkoutStats();
  }

  onMount(async () => {
    await loadData();
  });

  // Watch for sync completion (transition from syncing to not syncing)
  $: {
    const wasSyncing = previousSyncState;
    const isCurrentlySyncing = $syncStatus?.isSyncing || false;

    // Reload data when sync completes successfully
    if (wasSyncing && !isCurrentlySyncing && $syncStatus?.success) {
      loadData();
    }

    previousSyncState = isCurrentlySyncing;
  }

  // Format large numbers with thousand separators
  function formatNumber(num) {
    return num.toLocaleString('zh-TW');
  }
</script>

<div class="container mx-auto px-2 py-8 pb-24">
  <!-- Consecutive Weeks -->
  <div class="mb-6">
    <div class="card flex justify-between items-center">
      <h2 class="text-xl font-semibold">連續訓練週數</h2>

      <div class="flex justify-end items-center gap-x-2">
        <div class="text-3xl font-bold text-primary-600">{stats.consecutiveWeeks}</div>
        <span class="text-gray-600">週</span>
      </div>
    </div>
  </div>

  <!-- Training Statistics Cards -->
  <div class="grid grid-cols-3 gap-2 mb-8">
    <!-- Total Training Time -->
    <div class="card p-3">
      <div class="flex flex-col items-center text-center">
        <div class="text-2xl mb-1">⏱️</div>
        <div class="text-xs text-gray-600 mb-1">總時間</div>
        <div class="text-lg font-bold text-gray-800">
          {formatDuration(stats.totalDuration)}
        </div>
      </div>
    </div>

    <!-- Total Workouts -->
    <div class="card p-3">
      <div class="flex flex-col items-center text-center">
        <div class="text-2xl mb-1">🏋️</div>
        <div class="text-xs text-gray-600 mb-1">總次數</div>
        <div class="text-lg font-bold text-gray-800">
          {stats.totalWorkouts}<span class="text-sm text-gray-600">次</span>
        </div>
      </div>
    </div>

    <!-- Total Volume -->
    <div class="card p-3">
      <div class="flex flex-col items-center text-center">
        <div class="text-2xl mb-1">💪</div>
        <div class="text-xs text-gray-600 mb-1">總重量</div>
        <div class="text-lg font-bold text-gray-800">
          {formatNumber(Math.round(stats.totalVolume))}<span class="text-sm text-gray-600">kg</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Weight Trend Chart -->
  <div class="mb-8">
    <WeightChart records={weightRecords} on:reload={loadData} />
  </div>

  <!-- Workout Calendar -->
  <div class="mb-8">
    <WorkoutCalendar />
  </div>
</div>
